module.exports = __webpack_public_path__ + "img/chevron-up-black.c579037b.svg";